module.exports = __webpack_public_path__ + "img/mastercard-logo.12c82597.svg";